// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1cSCs","tab":"ProcedureTabs_tab__29jOT"};